import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import './Dailys.css';
import DailyTask from "./DailyTask";


function Dailys() {

    const {user} = useTypedSelector(state => state.auth);


    return <div className={'dailyContainer'}>
        <div className={'dailyTitleText'}>Daily Tasks:</div>

        <div className={'dailyTasksContainer'}>

                {Object.keys(user.dailys.active).map((item, index) => {

                    return <DailyTask key={'DailyTask_' + item} task={user.dailys.active[item]}/>
                })}
            {(user.dailys.active.length > 0) ?
                <div></div>
                :
                <div className={'dailyAvaiableSoon'}>Available soon...</div>
            }


        </div>

    </div>
}

export default Dailys